import { openMenu } from "./_menu";

$('a[href="#accessories-menu"]').click(function(e) {
    e.preventDefault();

    openMenu();

    var $accessories = $('.customer-menu .menu-wrapper > ul > li:first-child');
    $accessories.addClass('show-submenu');
});